<ngb-pagination *ngIf="itemCount>pageSize" [collectionSize]="itemCount" [size]="size"
    [(page)]="page" [pageSize]="pageSize" (pageChange)="setPage($event)" [maxSize]="3" [rotate]="true">
</ngb-pagination>
